export const WEBAPP_LOGIN_CLICKEDLOGINEMAILFIELD =
  'WEBAPP_LOGIN_CLICKEDLOGINEMAILFIELD';
export const WEBAPP_LOGIN_CLICKEDLOGINPASSWORDFIELD =
  'WEBAPP_LOGIN_CLICKEDLOGINPASSWORDFIELD';
export const WEBAPP_LOGIN_CLICKEDLOGIN = 'WEBAPP_LOGIN_CLICKEDLOGIN';
export const WEBAPP_LOGIN_CLICKEDONCREATEACCOUNT =
  'WEBAPP_LOGIN_CLICKEDONCREATEACCOUNT';
export const WEBAPP_SIGNUP_CLICKEDLOGININTOACCOUNT =
  'WEBAPP_SIGNUP_CLICKEDLOGININTOACCOUNT';
export const WEBAPP_LOGIN_CLICKEDRESETPASSWORDLINK =
  'WEBAPP_LOGIN_CLICKEDRESETPASSWORDLINK';
export const WEBAPP_LOGIN_CLICKEDOPENINTERCOM =
  'WEBAPP_LOGIN_CLICKEDOPENINTERCOM';
export const WEBAPP_LOGIN_ACCOUNTANT_CLICKEDLOGINEMAILFIELD =
  'WEBAPP_LOGIN_ACCOUNTANT_CLICKEDLOGINEMAILFIELD';
export const WEBAPP_LOGIN_ACCOUNTANT_CLICKEDLOGIN =
  'WEBAPP_LOGIN_ACCOUNTANT_CLICKEDLOGIN';
export const WEBAPP_LOGIN_ACCOUNTANT_CLICKEDCREATEACCOUNTLINK =
  'WEBAPP_LOGIN_ACCOUNTANT_CLICKEDCREATEACCOUNTLINK';
export const WEBAPP_LOGIN_ACCOUNTANT_CLICKEDOPENINTERCOM =
  'WEBAPP_LOGIN_ACCOUNTANT_CLICKEDOPENINTERCOM';
export const WEBAPP_LOGIN_GOOGLE_ACCOUNT = 'WEBAPP_LOGIN_GOOGLE_ACCOUNT';
export const WEBAPP_LOGIN_APPLE_ACCOUNT = 'WEBAPP_LOGIN_APPLE_ACCOUNT';
